import { render, staticRenderFns } from "./DecisionStart.vue?vue&type=template&id=65289a82&"
import script from "./DecisionStart.vue?vue&type=script&lang=js&"
export * from "./DecisionStart.vue?vue&type=script&lang=js&"
import style0 from "./DecisionStart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports